// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"7819851a","880":"7819851a"}[chunkId] + ".chunk.css";
};